import { computed, ref, watch } from 'vue'
import useApiRequest from '@/_core/hooks/useApiRequest'
import useEventEmitter from '@/_core/hooks/useEventEmitter'
import { getChildBook } from '@/services/books'
import store from '@/store'

export default function ChildBookContentsController () {
  const { $emit, $on, $off } = useEventEmitter()
  // Child book
  const childBook = ref(null)
  const childBookRequest = useApiRequest(getChildBook)
  childBookRequest.$on('success', () => {
    childBook.value = childBookRequest.data
    $emit('requestChildBook-success', childBookRequest.data)
  })
  childBookRequest.$on('error', () => {
    $emit('requestChildBook-error', childBookRequest.errors)
  })

  const _bookId = ref(null)
  const setBookId = id => { _bookId.value = id }

  const _childId = computed(() => store.user.selectedChild.id)
  const requestChildBook = async () => {
    if (_childId.value && _bookId.value) {
      await childBookRequest.request(_childId.value, _bookId.value)
    }
  }

  watch([_bookId, _childId], () => requestChildBook(), { immediate: true })

  return {
    childBook,
    setBookId,
    requestChildBook,
    isLoading: computed(() => childBookRequest.isLoading),
    $on,
    $off
  }
}
